import React, { Component } from "react";

class Social extends Component {
    render() {
        return (
            <div className="social">
                <a href="https://github.com/SevenTwoZ" aria-label="GitHub" target="_blank" rel="noopener noreferrer" className="fab fa-github"></a>
                <a href="https://www.instagram.com/knz_72/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="fab fa-instagram"></a>
                <a href="https://www.facebook.com/miku.yukkiyukki" aria-label="Facebook" target="_blank" rel="noopener noreferrer" className="fab fa-facebook"></a>
            </div>
        );
    }
}

export default Social;
